import AvatarGroup from "@material-ui/lab/AvatarGroup";
import Skeleton from '@mui/material/Skeleton';
import React from 'react';
const EventTaskSkelton = () => {
  return (
    <div className="eventCard mb-5">
      <div className="d-flex justify-content-center align-items-center h-100">
        <div className="card-content d-flex justify-content-between align-items-end" style={{ height: 81, paddingBottom: 8, paddingTop: 8 }} >
          <div className="text h-100 d-flex flex-column justify-content-between align-items-center">
            <Skeleton variant="rounded" width={100} height={16} />
            <Skeleton variant="rounded" width={100} height={16} />
          </div>
          <div className="event-avtars flex-grow-1 d-flex justify-content-end align-items-center">
            <AvatarGroup max={4} className="MuiAvatar-fallback justify-content-end align-items-center">
              <Skeleton variant="circular" width={40} height={40} className="IndexZero" />
              <Skeleton variant="circular" width={40} height={40} className="IndexOne" />
              <Skeleton variant="circular" width={40} height={40} className="IndexTwo" />
            </AvatarGroup>
          </div>
        </div>
      </div>
    </div>
  )
}

export default EventTaskSkelton